
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slots/providers",
      function () {
        return require("private-next-pages/slots/providers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slots/providers"])
      });
    }
  